/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { DonationState } from './types';
import { MutationRequestStatus, RootState } from '../types';

export const state: DonationState = {
  info: {
    status: undefined,
    error: undefined,
    data: undefined,
  },
  donation: {
    status: undefined,
    error: undefined,
    data: undefined,
  },
};

const namespaced = true;

export const donation: Module<DonationState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
